// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignDraggable/styles.scss
// module id = 857
// module chunks = 0